<template>
  <div class="about">
    <!-- 左侧文本区域 - 带L型金色边框 -->
    <div class="about-text-container">
      <h1>杭州笑口杏信息科技有限公司</h1>
      <p>杭州笑口杏信息科技有限公司集研发、运营、渠道等资源优化为一体。杭州笑口杏信息科技有限公司为融合不同客户群体需求，特推出杭州笑口杏信息科技有限公司信息服务平台。目前平台开发了四大板块：广告策划、企业咨询、数字内容制作、系统平台搭建等，可以满足不同用户群体发布产品信息的需求。用户注册登录后，可以发布自己的产品信息，我们平台将为其做好精准推流和交易撮合服务，以便客户对接到合适的业务。</p>
    </div>
    <!-- 右侧城市剪影装饰图 -->
    <!-- <div class="about-city-decor">
      <img src="../assets/about_city.png" alt="城市剪影" />
    </div> -->
  </div>
</template>
<script>
export default {
  name: "AboutView"
}
</script>
<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}

/* 整体全屏容器 - 匹配设计图黑金背景质感 */
.about{
  // width: 100%;
  height: 100vh;
  // min-height: 800px;
  box-sizing: border-box;
  /* 核心背景：可直接替换为设计图切图的背景图，当前渐变已匹配设计图底色质感 */
  background: url("../assets/about.png") no-repeat center center;
  background-size: cover;
  /* 备用渐变底色，无背景图时也能还原质感 */
  background-color: linear-gradient(135deg, #0a0a0a 0%, #1a1208 100%);
  // position: relative;
  // display: flex;
  // align-items: center;
  // padding: 0 0px;
  font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
  overflow: hidden;
  padding-left: 16vw;
  padding-top: 32vh;
  box-sizing: border-box;

  /* 左侧文本容器 - 还原L型金色边框 */
  .about-text-container{
    width: 50%;
    max-width: 620px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    padding: 40px 0;



    /* 标题样式 - 1:1匹配设计图 */
    h1{
      .fontdemo(50px, 'PingFangSC,PingFang SC', 600, #ffffff);
      margin: 0 0 20px 0;
      line-height: 1.2;
      text-align: left;
      font-size: 48px;
    }

    /* 正文样式 - 匹配设计图行高、字色、字号 */
    p{
      .fontdemo(18px, 'PingFangSC,PingFang SC', 400, #A7A7A7);
      line-height: 1.6;
      margin: 0;
      text-align: left;
      font-size: 24px;
    }
  }

  /* 右侧城市剪影装饰 - 固定在右下角，匹配设计图位置 */

}
</style>